import magnifiAPIInstance from "./apiInstance";

export const illustoProxy = {
  getProjectDetails: ({ payload }) => magnifiAPIInstance.post(`/illustoProxy`, payload),
  studioDownloadVttsAsZip: ({ payload }) =>
    magnifiAPIInstance.post(`/api/v3/${payload.orgId}/studio-project/${payload.projectId}/download-captions-as-zip`),
};
